import clsx from 'clsx';
import React from 'react';

import styles from './Card.module.scss';

export type SizeType = 'small' | 'medium' | 'large';

export interface CardProps {
  children?: React.ReactNode;
  size?: SizeType;
  className?: string;
}

export const Card = ({
  children,
  size = 'medium',
  className,
  ...rest
}: CardProps) => {
  return (
    <div
      data-testid="card"
      className={clsx(styles.root, styles[size], className)}
      {...rest}
    >
      {children}
    </div>
  );
};
